/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "subject_spoofer";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScenarioType {
}

export enum ScenarioType_Enum {
  NONE = 0,
  SQUARE = 1,
  CIRCLE = 2,
  SQUARE_WITH_ACC = 3,
  STATIC = 4,
  LINE = 5,
  DRAG_RACE = 6,
  UNRECOGNIZED = -1,
}

export function scenarioType_EnumFromJSON(object: any): ScenarioType_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return ScenarioType_Enum.NONE;
    case 1:
    case "SQUARE":
      return ScenarioType_Enum.SQUARE;
    case 2:
    case "CIRCLE":
      return ScenarioType_Enum.CIRCLE;
    case 3:
    case "SQUARE_WITH_ACC":
      return ScenarioType_Enum.SQUARE_WITH_ACC;
    case 4:
    case "STATIC":
      return ScenarioType_Enum.STATIC;
    case 5:
    case "LINE":
      return ScenarioType_Enum.LINE;
    case 6:
    case "DRAG_RACE":
      return ScenarioType_Enum.DRAG_RACE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScenarioType_Enum.UNRECOGNIZED;
  }
}

export function scenarioType_EnumToJSON(object: ScenarioType_Enum): string {
  switch (object) {
    case ScenarioType_Enum.NONE:
      return "NONE";
    case ScenarioType_Enum.SQUARE:
      return "SQUARE";
    case ScenarioType_Enum.CIRCLE:
      return "CIRCLE";
    case ScenarioType_Enum.SQUARE_WITH_ACC:
      return "SQUARE_WITH_ACC";
    case ScenarioType_Enum.STATIC:
      return "STATIC";
    case ScenarioType_Enum.LINE:
      return "LINE";
    case ScenarioType_Enum.DRAG_RACE:
      return "DRAG_RACE";
    case ScenarioType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseScenarioType(): ScenarioType {
  return {};
}

export const ScenarioType = {
  encode(_: ScenarioType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScenarioType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScenarioType {
    return {};
  },

  toJSON(_: ScenarioType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioType>, I>>(base?: I): ScenarioType {
    return ScenarioType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioType>, I>>(_: I): ScenarioType {
    const message = createBaseScenarioType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
